/**
 * alfavita-quiz.js
 * 3-step hair loss diagnostic quiz for AlfaVita Shopify store.
 * Collects Q1, Q2, and email answers → logs to Notion via Cloudflare Worker.
 */

(function () {
  'use strict';

  // ── State ──────────────────────────────────────────────────────────────────
  var answers = { q1: '', q2: '', email: '' };

  // ── DOM references (resolved after DOMContentLoaded) ─────────────────────
  var wrap, form, emailInput, errorEl;

  // ── Step navigation ───────────────────────────────────────────────────────
  function goToStep(n) {
    document.querySelectorAll('.avq-step').forEach(function (s) {
      s.classList.remove('avq-active');
    });
    var target = document.getElementById('avq-' + n);
    if (target) {
      target.classList.add('avq-active');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  // ── Q1 / Q2 click handler ─────────────────────────────────────────────────
  function handleOptionClick(e) {
    var el = e.currentTarget;
    var q = el.dataset.q;
    var answer = el.dataset.answer;
    if (!q || !answer) return;

    answers['q' + q] = answer;

    // Visual feedback: briefly highlight then advance
    el.style.borderColor = '#005bd3';
    el.style.background = '#eef3ff';
    setTimeout(function () {
      goToStep(parseInt(q, 10) + 1);
    }, 160);
  }

  // ── Q3 form submit ────────────────────────────────────────────────────────
  function handleSubmit(e) {
    e.preventDefault();
    var email = emailInput.value.trim();

    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.style.display = 'block';
      emailInput.focus();
      return;
    }
    errorEl.style.display = 'none';
    answers.email = email;

    // Disable form to prevent double-submit
    form.classList.add('avq-loading');

    var workerUrl = (wrap.dataset.worker || '').trim();
    var redirectUrl = (wrap.dataset.redirect || '/pages/alfavita2').trim();

    function doRedirect() {
      window.location.href = redirectUrl;
    }

    if (workerUrl) {
      // Fire-and-forget: send data then redirect regardless of outcome
      var body = JSON.stringify({
        email: answers.email,
        q1: answers.q1,
        q2: answers.q2,
        source: window.location.href
      });

      fetch(workerUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
      })
        .then(doRedirect)
        .catch(doRedirect);

      // Safety net: redirect after 3 s even if fetch hangs
      setTimeout(doRedirect, 3000);
    } else {
      // No worker configured → redirect immediately
      doRedirect();
    }
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    wrap = document.querySelector('.avq-wrap');
    if (!wrap) return;

    form = document.getElementById('avq-form');
    emailInput = document.getElementById('avq-email');
    errorEl = document.getElementById('avq-error');

    // Bind Q1 cards
    document.querySelectorAll('.avq-card[data-q]').forEach(function (card) {
      card.addEventListener('click', handleOptionClick);
    });

    // Bind Q2 buttons
    document.querySelectorAll('.avq-choice[data-q]').forEach(function (btn) {
      btn.addEventListener('click', handleOptionClick);
    });

    // Bind email form
    if (form) {
      form.addEventListener('submit', handleSubmit);
    }

    // Hide error on email input change
    if (emailInput && errorEl) {
      emailInput.addEventListener('input', function () {
        errorEl.style.display = 'none';
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
